import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-doctors-next-button',
  templateUrl: './doctors-next-button.component.html',
  styleUrls: [
    './doctors-next-button.component.css',
    '../style/index.css',
    '../style/registration.css',
  ],
})
export class DoctorsNextButtonComponent implements OnInit {
  @Input()
  label: string = '';

  @Input()
  type: 'primary' | 'outline' = 'primary';

  constructor() {}

  ngOnInit(): void {}
}
